import type { RecentlyViewedContentType } from '@mfw/common';

import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { Locale } from '../../../@mfw-translations';

import { fetchRecentlyViewedContent } from '../api/recentlyViewed.api';

export const recentlyViewedQueryKeys = createQueryKeys('recentlyViewed', {
  fetchContent: ({
    contentType,
    limit,
    locale,
    organizationId,
    assignedOnly,
  }: {
    contentType: RecentlyViewedContentType;
    locale: Locale;
    limit: number;
    organizationId?: string;
    assignedOnly?: boolean;
  }) => ({
    queryFn: () =>
      fetchRecentlyViewedContent({
        contentType,
        limit,
        locale,
        organizationId,
        assignedOnly,
      }),
    queryKey: [organizationId, contentType, limit, !!assignedOnly],
  }),
});
